<mat-card class="cardWithShadow">
    <mat-card-content>
        <div class="header" style="margin-bottom: 15px; text-align: center;">
            <mat-card-title class="header-title">{{ getTitle() }}</mat-card-title><br>
        </div>
        <div class="content">
            <div class="d-flex flex-column" style="width: 100%;">
                <mat-form-field appearance="outline" style="width: 100%;">
                    <mat-label>Comentario</mat-label>
                    <textarea matInput rows="3" [(ngModel)]="comment" #commentField="ngModel" required></textarea>
                    <mat-error *ngIf="isCommentInvalid ">
                        El comentario es obligatorio.
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="button-container">
                <button color="primary" mat-flat-button (click)="validarComentario(data.accion)" [disabled]="load">
                    @if(load){
                        <mat-spinner diameter="20"></mat-spinner>
                    } @else {
                        {{ getTitle() }}
                    }
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
